import React from 'react'
import { useLocation } from 'react-router-dom'

import CreateUserRole from '../../../components/CreateUserRole'
import ContextMenu from '../../../components/ContextMenu'

export default function () {
  const query = new URLSearchParams(useLocation().search)
  const organizationId = parseInt(query.get('organizationId'))

  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Create a new user role</h1>}></ContextMenu>
      <CreateUserRole organizationId={organizationId} />
    </div>
  )
}
